import { NgModule } from '@angular/core'
import { IsDisabledDirective } from './is-disabled.directive'

@NgModule({
  declarations: [IsDisabledDirective],
  exports: [IsDisabledDirective]
})
export class IsDisabledDirectiveModule {}
